export default __webpack_public_path__ + "media/images/images/portfolio/width-600/portfolio-25-71650cbcfe3df959380a6659165f2661.jpg";